import { Grid } from 'antd'

/**
 * Screen-width decisions of the two backoffices live in this folder only (개발항목 199,
 * AGENTS.md "같은 기능은 한곳에서만 구현한다"). Screens do not ask antd for the breakpoint
 * themselves (ESLint `no-restricted-imports` blocks `Grid`); what changes with the width is either
 * a rule in `responsive.css` or this hook.
 *
 * The widths, in one place:
 * - below 1200px (antd `xl`): the side menu becomes a drawer opened by `MenuDrawerButton`
 * - below 768px (antd `md`): the phone rules of `responsive.css` apply
 */

/**
 * True when the side menu is shown as a drawer instead of the fixed side bar.
 *
 * antd reports no breakpoint until it has measured the window; that first render counts as wide so
 * it matches the PC layout the page had before.
 */
export function useUsesDrawerMenu(): boolean {
  const breakpoint = Grid.useBreakpoint()
  return breakpoint.xl === undefined ? false : !breakpoint.xl
}
